import { Navigate } from 'react-router';
import type { ReactNode } from 'react';
import { useTutorProfile } from '@/lib/tutor-profile-context';

/**
 * Gates tutor areas (My Classes, Earnings) that only carry data once the
 * profile is approved and live. While the profile is still draft / in review /
 * paused these routes redirect home, where the dashboard explains the status —
 * matching the locked sidebar tabs. Relies on `TutorProfileProvider`, which
 * `DashboardLayout` mounts around every tutor route.
 */
export function RequirePublishedTutor({ children }: { children: ReactNode }) {
  const tutorCtx = useTutorProfile();

  // Wait for the profile to load before deciding, to avoid a redirect flash.
  if (!tutorCtx || tutorCtx.loading) return null;

  if (tutorCtx.profile?.publishStatus !== 'published') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
